import { normalizeStrokeWidth } from './utils/normalizeStrokeWidth.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from '../utils/style.svg.js';

const PM2WhiskerIcon = ({
  color = "currentColor",
  strokeWidth = 1.5,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    xmlns: "http://www.w3.org/2000/svg",
    ...svgProps,
    viewBox: "0 0 21.136 21.139",
    fill: "none",
    stroke: color,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: normalizeStrokeWidth(strokeWidth, 21.139),
    children: [/*#__PURE__*/jsx("path", {
      d: "m4.124 19.95a2.077 2.077 0 0 1 -2.933-2.937l4.4-4.406 2.94 2.937z"
    }), /*#__PURE__*/jsx("path", {
      d: "m5.783 12.797c-.426-3.19 2.227-8.482 4.216-10.471a6.231 6.231 0 1 1 8.811 8.812c-1.989 1.989-7.281 4.642-10.471 4.216"
    }), /*#__PURE__*/jsx("path", {
      d: "m6.494 13.508c.58-2.189 3.964-6.745 5.953-8.734 2.433-2.433 5.282-3.53 6.364-2.448s-.015 3.931-2.448 6.364c-1.988 1.989-6.545 5.374-8.734 5.953"
    })]
  });
};

export { PM2WhiskerIcon };
//# sourceMappingURL=whisker.js.map
